module.exports = __webpack_public_path__ + "img/IMG_Phone_4.acaec2fb.jpg";